import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { CustomFilterService } from 'path-shared/services/datasource/custom-filter-service';
import { ResolucionFilter } from '../models/NotificacionDenuncia/resolucion-filter';


const defaultSortParam = 'element';
const defaultSortDirection = 'asc';

@Injectable()
export class ResolucionsFilterService extends CustomFilterService {
  public createFilterParams(filter: ResolucionFilter, start: number, pageSize: number, sortField: string, sortDir: string ) {

    return new HttpParams()
    .append('dataIni', filter.dataIni ? filter.dataIni.toJSON() : '')
    .append('dataFi', filter.dataFi ? filter.dataFi.toJSON() : '')
    .append('start', start.toString())
    .append('size', pageSize.toString())
    .append('sortparam', sortField === undefined ? defaultSortParam : sortField)
    .append('sortdir', sortDir === '' ? defaultSortDirection : sortDir);
  }
}
